// extracted by mini-css-extract-plugin
export default {"container":"toggle_container__gW4GX","toggleSwitch":"toggle_toggleSwitch__Xzjlc"};